import { render, staticRenderFns } from "./CheckDataList.vue?vue&type=template&id=064cbbb2"
import script from "./CheckDataList.vue?vue&type=script&lang=js"
export * from "./CheckDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports